import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { ApiService } from '../../api/api.service';

@Injectable({
  providedIn: 'root',
})
export class TabService {
  private tabsCache = new Map<string, Observable<any>>();

  constructor(private apiService: ApiService) {}

  getTabs(moduleName: string): Observable<any> {
    if (!this.tabsCache.has(moduleName)) {
      this.tabsCache.set(
        moduleName,
        this.apiService
          .get('customer/tab', { module: moduleName }, true)
          .pipe(shareReplay(1)),
      );
    }
    return this.tabsCache.get(moduleName)!;
  }

  getCustomerTabs(moduleName: string) {
    return this.apiService.get(
      'customer/tab/active',
      { module: moduleName },
      true,
    );
  }

  updateCustomerTabs(payloads: any) {
    return this.apiService.post('customer/tab/active', payloads, true);
  }
}
